import { Fragment, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import validator from "email-validator";

const navigation = [
  { name: "Home", href: "#Home", current: true },
  { name: "Features", href: "#Features", current: false },
  { name: "Avatars", href: "#Avatars", current: false },
  {
    name: "Contact us - Join Discord",
    href: "#JoinOurDiscord",
    current: false,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleJoinWaitlistClick = () => {
    try {
      setShowModal(true);
    } catch (err) {
      console.log(err, "error message");
    }

    // api call to store email
  };

  const handleSubmit = async (event) => {
    if(validator.validate(email)){
        try {
            event.preventDefault();
            console.log(email);
            setEmail("");
      
            // remeber to replace with nvironment variabke
            const options = {
              url: `https://jrcaz6pgvcrim5tcgj3bvdq2mu0klghj.lambda-url.eu-north-1.on.aws?email=${email}`,
              data: { email },
              method: "POST",
            };
            console.log(options, "mai axios opt hu");
            const response = await axios(options);
            console.log("mai response hu", response);
            setShowModal(false);
            toast(
              "Thanks for dropping your email! 🚀 Get ready for some awesomeness. Hang tight for 10 minutes and keep an eye on your inbox! Our squad will slide into your DMs shortly. Stay tuned! ✨"
            );
          } catch (err) {
            console.log(err);
          }
    }
    else{toast("Please enter a valid email address")}
    
  };
  return (
    <>
      <Disclosure as="nav" className="bg-[#32325D]">
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
              <div className="relative flex items-center justify-between h-16">
                <div className="flex-shrink-0">
                  <h1 className="text-[#7C82FF] text-3xl tracking-wide font-bold">
                    AINA
                  </h1>
                </div>
                <div className="hidden custom:flex custom:space-x-4">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "text-white"
                          : "text-gray-300 hover:text-[#7C82FF]",
                        "px-3 py-2 rounded-md text-base font-medium hover:text-[#7C82FF]"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div className="flex items-center">
                  <button
                    onClick={handleJoinWaitlistClick}
                    className="bg-[#7C82FF] mr-12 border-[#7C82FF] border-2 hover:bg-[#32325D] hover:text-white text-white font-semibold py-2 px-10 rounded-lg transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#4F4484] focus:ring-white"
                  >
                    Get Started
                  </button>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center custom:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-8 w-8" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="custom:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={classNames(
                      item.current
                        ? "text-white"
                        : "text-gray-300 hover:text-white",
                      "block px-3 py-2 rounded-md text-base font-medium"
                    )}
                    aria-current={item.current ? "page" : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>

      {showModal && (
        <div className="fixed inset-0 z-50 overflow-auto bg-smoke-light flex">
          <div className="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-lg shadow-lg">
            <div className="flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="text-[#7C82FF] rounded-md p-1.5 inline-flex items-center justify-center hover:bg-[#ebedff] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7C82FF]"
              >
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                <span className="sr-only">Close</span>
              </button>
            </div>
            <form
              onSubmit={handleSubmit}
              className="mt-4 sm:mt-6 flex flex-col space-y-4"
            >
              <div>
                <label
                  htmlFor="email"
                  className="text-lg font-bold text-[#32325D] block"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded mt-1 focus:ring-[#7C82FF] focus:border-[#7C82FF]"
                />
              </div>
              <button
                type="submit"
                className="bg-[#7C82FF] text-white font-bold py-2 px-4 rounded hover:bg-[#5a5fcf] transition ease-in-out duration-300"
              >
                Join Waitlist
              </button>
            </form>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{
          maxWidth: "600px",
        }}
        progressStyle={{
          background: "#7C82FF",
        }}
      />
    </>
  );
}
